"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eqStrMapInterpreter = void 0;
var utils_1 = require("@morphic-ts/common/lib/utils");
var function_1 = require("fp-ts/function");
var Record_1 = require("fp-ts/Record");
var config_1 = require("../config");
var hkt_1 = require("../hkt");
/**
 *  @since 0.0.1
 */
exports.eqStrMapInterpreter = utils_1.memo(function () { return ({
    _F: hkt_1.EqURI,
    strMap: function (getCodomain, config) { return function (env) {
        return function_1.pipe(getCodomain(env).eq, function (eq) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(Record_1.getEq(eq), env, { eq: eq })); });
    }; },
    record: function (getDomain, getCodomain, config) { return function (env) {
        // domain is always comparable (this is handled by record Eq)
        return (function (domainEq, codomainEq) { return new hkt_1.EqType(config_1.eqApplyConfig(config)(Record_1.getEq(codomainEq), env, { domainEq: domainEq, codomainEq: codomainEq })); })(getDomain(env).eq, getCodomain(env).eq);
    }; }
}); });
